// Seitenweise Listen (Mieterliste: 20 je Seite). Reine Funktionen – testbar.

export interface Seite<T> { eintraege: T[]; seite: number; seiten: number; von: number; bis: number; gesamt: number }

/** Ausschnitt einer Seite; die Seite wird auf 1 … seiten begrenzt. von/bis sind 1-basiert (Anzeige „21–40 von 683“). */
export function seiteAus<T>(liste: readonly T[], seite: number, proSeite: number): Seite<T> {
  const gesamt = liste.length;
  const seiten = Math.max(1, Math.ceil(gesamt / proSeite));
  const s = Math.min(seiten, Math.max(1, Math.floor(seite) || 1));
  const start = (s - 1) * proSeite;
  const eintraege = liste.slice(start, start + proSeite);
  return { eintraege, seite: s, seiten, von: gesamt ? start + 1 : 0, bis: start + eintraege.length, gesamt };
}

/** Seitenknöpfe mit Lücken: 1 … 4 5 6 … 35 (immer erste, letzte und ±1 um die aktuelle). */
export function seitenListe(seite: number, seiten: number): (number | 'luecke')[] {
  if (seiten <= 7) return Array.from({ length: seiten }, (_, i) => i + 1);
  const zeigen = new Set([1, seiten, seite - 1, seite, seite + 1]);
  if (seite <= 3) [2, 3, 4].forEach(n => zeigen.add(n));
  if (seite >= seiten - 2) [seiten - 3, seiten - 2, seiten - 1].forEach(n => zeigen.add(n));
  const nummern = [...zeigen].filter(n => n >= 1 && n <= seiten).sort((a, b) => a - b);
  const aus: (number | 'luecke')[] = [];
  nummern.forEach((n, i) => {
    const vorher = nummern[i - 1];
    if (vorher !== undefined && n - vorher > 1) aus.push('luecke');
    aus.push(n);
  });
  return aus;
}
